var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-email-list"},[_c('list',{attrs:{"addLink":_vm.addLink,"api":_vm.api,"apiList":_vm.apiList,"fs":_vm.fs,"showDelete":_vm.showDelete,"title":"Order Email Sending Record"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }